var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex h-full w-full items-center justify-center p-4"},[_c('Icon',{staticClass:"fa-spin text-2xl text-gray-500",attrs:{"name":"spinner-third","set":"fad"}}),_vm._v(" "),(_vm.message)?_c('div',{staticClass:"ml-3 text-lg text-gray-600",domProps:{"textContent":_vm._s(_vm.message)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }